let activeInCart = [];
// Shipping and minimum order amounts
let freeShippingThreshold = window.siteWideSettings.freeShippingThreshold;
const enableGwpDollarThreshold = window.siteWideSettings.enableGwpDollarThreshold;
const enableTieredGwpDollarThreshold = window.siteWideSettings.enableTieredGwpDollarThreshold;
const enableAutoSampleCart = window.siteWideSettings.enableAutoSampleCart;
const singleEntryVariantId = window.siteWideSettings.singleEntryVariantId;
const multipleEntryVariantId = window.siteWideSettings.multipleEntryVariantId;
const enableProductBasedGWP = window.siteWideSettings.enableProductBasedGwp;

let productBasedGwpVariantId;
let autoSampleID;
let tier1GwpThreshold;
let tier1GwpVariantIDs;
let tier1GwpMessage;
let tier2GwpThreshold;
let tier2GwpVariantIDs;
let tier2GwpMessage;
let gwpThreshold;
let gwpVariantId;
let gwpMessage;
let productBasedGwpTrigger100;
let productBasedGwpTrigger50;
let productBasedProgress;
let collectionVariantIds;

if (enableAutoSampleCart == true) {
  autoSampleID = window.siteWideSettings.autoSampleID;
}

if (enableGwpDollarThreshold == true) {
  singleGwpThreshold = window.siteWideSettings.singleGwpThreshold;
  singleGwpVariantId = window.siteWideSettings.singleGwpVariantId;
  singleGwpMessage = window.siteWideSettings.singleGwpMessage;
}

if (enableProductBasedGWP == true) {
  productBasedGwpVariantId = window.siteWideSettings.productBasedGwpVariantId;
  productBasedGwpTrigger100 = window.siteWideSettings.productBasedGwpTrigger100;
  productBasedGwpTrigger50 = window.siteWideSettings.productBasedGwpTrigger50;
   // Get settings from window object
  productBasedGwpVariantId = window.siteWideSettings.productBasedGwpVariantId;
  productBasedGwpTrigger100 = window.siteWideSettings.productBasedGwpTrigger100;
  productBasedGwpTrigger50 = window.siteWideSettings.productBasedGwpTrigger50;
  collectionVariantIds = window.siteWideSettings.productBasedGwpCollectionProducts;

}

if (enableTieredGwpDollarThreshold == true) {
  tier1GwpThreshold = window.siteWideSettings.tier1GwpThreshold;
  tier1GwpVariantIDs = window.siteWideSettings.tier1GwpVariantIDs;
  tier1GwpMessage = window.siteWideSettings.tier1GwpMessage;
  tier2GwpThreshold = window.siteWideSettings.tier2GwpThreshold;
  tier2GwpVariantIDs = window.siteWideSettings.tier2GwpVariantIDs;
  tier2GwpMessage = window.siteWideSettings.tier2GwpMessage;
}

(function (window, document) {
  "use strict";
  var AgileCart = function (options) {
    var defaults = {
      // Defaults configuration
      cartTrigger: ".js-go-cart-trigger",
      cartHeaderTotal: ".header-cart__total",
      cartDrawer: ".js-go-cart-drawer",
      cartDrawerContent: ".js-go-cart-drawer-content",
      cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
      cartDrawerFooter: ".cart-drawer__footer",
      cartDrawerClose: ".js-go-cart-drawer-close",
      cartRemoveAll: ".cart-drawer__remove-all",
      cartPageContent: ".cart__items--wrapper",
      cartTotalWrapper: ".cart-totals-wrapper",
      cartOverlay: ".js-go-cart-overlay",
      cartCount: ".js-go-cart-counter",
      addToCart: ".js-go-cart-add-to-cart",
      addToCartSearch: ".quick-add__submit-search",
      removeFromCart: ".go-cart-item__remove",
      itemQuantity: ".js-go-cart-quantity",
      itemQuantityPlus: ".js-go-cart-quantity-plus",
      itemQuantityMinus: ".js-go-cart-quantity-minus",
      cartCollection: ".go-cart__collection",
      shippingThresholdTextWrapper: ".threshold__text",
      numberElement: ".cart-shipping__num",
      freeShippingProgress: ".cart-shipping__numOuter",
      cartSuccessMessage: ".cart-shipping__success",
      cartProgressBar: ".cart-shippingThreshold__progress",
      cartShippingWrapper: ".cart-shipping__wrapper",
      cartShippingDisclaimer: ".cart-reserve__wrapper",
      liquorContainer: ".liquor-check-age",
      minSpendWrapper: ".min-cart-spend",
      moneyFormat: "${{amount}}",
    };

    this.settings = Object.assign({}, defaults, options);
    this.init();
    this.bindEvents();
  };

  AgileCart.prototype.init = function () {
    this.cartTrigger = document.querySelector(this.settings.cartTrigger);
    this.cartHeaderTotal = document.querySelector(
      this.settings.cartHeaderTotal
    );
    this.cartDrawer = document.querySelector(this.settings.cartDrawer);
    this.cartDrawerContent = document.querySelector(
      this.settings.cartDrawerContent
    );
    this.cartDrawerSubTotal = document.querySelector(
      this.settings.cartDrawerSubTotal
    );
    this.cartDrawerFooter = document.querySelector(
      this.settings.cartDrawerFooter
    );
    this.cartDrawerClose = document.querySelector(
      this.settings.cartDrawerClose
    );
    this.cartPageContent = document.querySelector(
      this.settings.cartPageContent
    );
    this.cartTotalWrapper = document.querySelector(
      this.settings.cartTotalWrapper
    );
    this.cartOverlay = document.querySelector(this.settings.cartOverlay);
    this.cartCount = document.querySelector(this.settings.cartCount);
    this.addToCart = document.querySelector(this.settings.addToCart);
    this.addToCartSearch = document.querySelector(
      this.settings.addToCartSearch
    );
    this.removeFromCart = document.querySelector(this.settings.removeFromCart);
    this.itemQuantity = document.querySelector(this.settings.itemQuantity);
    this.itemQuantityPlus = document.querySelector(
      this.settings.itemQuantityPlus
    );
    this.itemQuantityMinus = document.querySelector(
      this.settings.itemQuantityMinus
    );
    this.cartCollection = document.querySelector(this.settings.cartCollection);
    this.shippingThresholdTextWrapper = document.querySelectorAll(
      this.settings.shippingThresholdTextWrapper
    );
    this.numberElement = document.querySelectorAll(this.settings.numberElement);
    this.freeShippingProgress = document.querySelectorAll(
      this.settings.freeShippingProgress
    );
    this.cartSuccessMessage = document.querySelector(
      this.settings.cartSuccessMessage
    );
    this.cartProgressBar = document.querySelectorAll(
      this.settings.cartProgressBar
    );
    this.cartShippingWrapper = document.querySelector(
      this.settings.cartShippingWrapper
    );
    this.cartShippingDisclaimer = document.querySelector(
      this.settings.cartShippingDisclaimer
    );
    this.minSpendWrapper = document.querySelectorAll(
      this.settings.minSpendWrapper
    );
    this.liquorContainer = document.querySelector(
      this.settings.liquorContainer
    );
    this.fetchCart();
  };

  AgileCart.prototype.bindEvents = function () {
    var self = this;

    this.cartTrigger.addEventListener("click", function () {
      document.body.classList.add("overflow-hidden");
      self.fetchCart();
      self.openCartOverlay();
    });

    this.cartOverlay.addEventListener("click", function () {
      document.body.classList.remove("overflow-hidden");
      self.closeCartOverlay();
    });

    this.cartDrawerClose.addEventListener("click", function () {
      document.body.classList.remove("overflow-hidden");
      self.closeCartOverlay();
    });

    document.addEventListener("click", function (event) {
      if (event.target.matches(self.settings.cartRemoveAll)) {
        if (confirm("Are you sure?")) {
          self.removeAll();
          if (isCartTemplate) {
            self.cartPageContent.classList.add("updating-cart");
          } else {
            self.cartDrawerContent.classList.add("updating-cart");
          }
          self.renderBlankCartDrawer();
        }
      }
    });

    document.addEventListener(
      "click",
      function (event) {
        // Check if the clicked element matches the add-to-cart selector
        if (event.target.matches(self.settings.addToCart)) {
          event.preventDefault();
          self.cartDrawerContent.classList.add("updating-cart");

          // Get the form associated with the clicked button and add the item to the cart
          var formElement = event.target.closest("form");
          var formId = formElement.getAttribute("id");
          self.addItemToCart(formId);

          // Remove the 'show-quick-view' class from the body
          document.body.classList.remove("show-quick-view");

          // Find any open quickview popups and remove the 'open-qv-popup' class
          document
            .querySelectorAll(".quickview-popup.open-qv-popup")
            .forEach((popup) => {
              popup.classList.remove("open-qv-popup");
            });
        }
      },
      false
    );

    document.addEventListener(
      "click",
      function (event) {
        if (event.target.matches(self.settings.removeFromCart)) {
          if (event.target.matches(".bundle-remove")) {
            self.cartDrawerContent.classList.add("updating-cart");
            var bundleKeys = event.target.getAttribute("data-bundle-keys"); // Assuming bundleID is stored in a data attribute
            self.removeItemsByKeys(bundleKeys);
          } else {
            self.cartDrawerContent.classList.add("updating-cart");
            var lineItemElement = event.target.closest(".go-cart-item__single");
            var lineNumber = lineItemElement.getAttribute("data-line");
            self.removeItem(lineNumber);
          }
        }
      },
      false
    );

    document.addEventListener(
      "click",
      function (event) {
        if (event.target.matches(self.settings.itemQuantityPlus)) {
          self.cartDrawerContent.classList.add("updating-cart");
          var itemElement = event.target.closest(".go-cart-item__single");
          let maxQuantity = parseInt(
            itemElement.querySelector(self.settings.itemQuantity).max
          );
          var line = itemElement.getAttribute("data-line");
          var currentQuantity = parseInt(
            itemElement.querySelector(self.settings.itemQuantity).value,
            10
          );
          if (isNaN(currentQuantity) || currentQuantity < maxQuantity) {
            self.changeItemQuantity(line, currentQuantity + 1);
          } else {
            console.error("Maximum quantity reached");
            itemElement.querySelector(".product-error__container").innerHTML =
              "Maximum quantity in cart";

            setTimeout(function () {
              itemElement.querySelector(".product-error__container").innerHTML =
                "";
            }, 2000);
          }
        }

        if (event.target.matches(self.settings.itemQuantityMinus)) {
          self.cartDrawerContent.classList.add("updating-cart");
          var itemElement = event.target.closest(".go-cart-item__single");
          var line = itemElement.getAttribute("data-line");
          var currentQuantity = parseInt(
            itemElement.querySelector(self.settings.itemQuantity).value,
            10
          );
          // Check if currentQuantity is greater than 1
          if (currentQuantity > 1) {
            self.changeItemQuantity(line, currentQuantity - 1);
          } else {
            self.removeItem(line);
          }
        }
      },
      false
    );

    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  };

  (AgileCart.prototype.fetchCart = function () {
    console.log("fetchCart");
    let self = this;
    let productsInCartArray = [];
    let productUpdates = [];
    let currentCartValue = 0;
    let cartItemTotal = 0;
    let gwpToAdd = [];
    window
      .fetch("/cart.js", { credentials: "same-origin", method: "GET" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        currentCartValue = cart.total_price;
        cartItemTotal = cart.item_count;

        cart.items.forEach((item) => {
          const {
             title: itemTitle,
             variant_id: itemId,
             quantity: itemQuantity,
             key: itemKey,
             price: itemPrice,
             product_type: itemType,
             properties: itemProperties  // Add this line
           } = item;

           productsInCartArray.push({ 
             title: itemTitle,
             id: itemId, 
             key: itemKey,
             quantity: itemQuantity,
             properties: itemProperties || {}  // Add properties to the pushed object
           });
        });

        self.fetchHandler(cart, cartItemTotal, currentCartValue);
        self.freeShippingCalculator(currentCartValue);

        console.log(productsInCartArray);

        if(enableAutoSampleCart) {
          const autoSampleInCart = productsInCartArray.some(item => item.id === autoSampleID);
          const onlyAutoSampleInCart = autoSampleInCart && productsInCartArray.length === 1;
          
          if(currentCartValue > 0 && !onlyAutoSampleInCart) {
            if(!autoSampleInCart) {
               self.updateItemQuantity([{ id: autoSampleID, quantity: 1 }]);
            }
          } else {
            if(autoSampleInCart) {
              self.updateItemQuantity([{ id: autoSampleID, quantity: 0 }]);
            }
          }
        } 

        if (enableGwpDollarThreshold) {
      // Check for existing single GWP in cart
      const singleGwpInCart = productsInCartArray.find(product => 
        product.id === singleGwpVariantId && 
        product.properties && 
        product.properties['_GwpType'] === 'single'
      );

      // Below threshold - remove gift if present
      if (currentCartValue < singleGwpThreshold) {
        if (singleGwpInCart) {
          self.cartDrawerContent.classList.add("updating-cart");
          self.updateItemQuantity([{ 
            id: singleGwpVariantId, // Use the key from the found item
            quantity: 0
          }]);
        }
      } 
      // Above threshold - add gift if not present
      else if (currentCartValue >= singleGwpThreshold && !singleGwpInCart) {
        self.cartDrawerContent.classList.add("updating-cart");
        self.addItemsToCart([{
          id: singleGwpVariantId,
          quantity: 1,
          properties: {
            '_GwpType': 'single'
          }
        }]);
      }
    }
        
        if (enableTieredGwpDollarThreshold) {
          // Check for existing gifts in cart
          const tier1GwpInCart = productsInCartArray.find(product => 
             tier1GwpVariantIDs.includes(product.id) && 
             product.properties && 
             product.properties['_Tier'] === 'tier1'
          );

          const tier1EntryInCart = productsInCartArray.some(item => item.id === singleEntryVariantId);
    
          const tier2GwpInCart = productsInCartArray.find(product => 
             tier2GwpVariantIDs.includes(product.id) && 
             product.properties && 
             product.properties['_Tier'] === 'tier2'
          );

          const tier2EntryInCart = productsInCartArray.some(item => item.id === multipleEntryVariantId);

          console.log(productsInCartArray);
          console.log('Tier 1 GWP Key:', tier1GwpInCart ? tier1GwpInCart.key : 'Not in cart');
          console.log('Tier 2 GWP Key:', tier2GwpInCart ? tier2GwpInCart.key : 'Not in cart');
          console.log(currentCartValue);
          
          // Remove any existing classes
          self.cartDrawer.classList.remove('show-gift-selections', 'show-tier1', 'show-tier2');

          // Below tier1 threshold - remove any gifts
          if (currentCartValue < tier1GwpThreshold) {
            if (tier1GwpInCart || tier2GwpInCart || tier1EntryInCart || tier2EntryInCart) {
              const giftsToRemove = [];
              if (tier1GwpInCart) giftsToRemove.push({ id: tier1GwpInCart.key, quantity: 0 });
              if (tier2GwpInCart) giftsToRemove.push({ id: tier2GwpInCart.key, quantity: 0 });
              if (tier1EntryInCart) giftsToRemove.push({ id: singleEntryVariantId, quantity: 0 });
              if (tier2EntryInCart) giftsToRemove.push({ id: multipleEntryVariantId, quantity: 0 });
              self.cartDrawerContent.classList.add("updating-cart");
              self.updateItemQuantity(giftsToRemove);
            }
          }
          // Between tier1 and tier2 threshold
          else if (currentCartValue >= tier1GwpThreshold && currentCartValue < tier2GwpThreshold) {
            console.log('Tier1 Entry ' + tier1EntryInCart)
            console.log('Tier2 Entry ' + tier2EntryInCart)
            // Remove tier2 gift if present
            if(tier2EntryInCart == true) {
              if (tier2GwpInCart) {
                console.log(tier2GwpInCart.key)
                self.cartDrawerContent.classList.add("updating-cart");
                self.updateItemQuantity([
                  { id: multipleEntryVariantId, quantity: 0 },
                  { key: tier2GwpInCart.key, quantity: 0 }
                ]); 
              } else {
                console.log('SADSDAD')
                self.updateItemQuantity([{ id: multipleEntryVariantId, quantity: 0 }]);
              }
            } else {
              if (tier2GwpInCart) {
                 self.cartDrawerContent.classList.add("updating-cart");
                 self.updateItemQuantity([{ key: tier2GwpInCart.key, quantity: 0 }]);
              }
            }
          
            // Show tier1 selection if no tier1 gift
            if (!tier1GwpInCart) {
               if(singleEntryVariantId != null && !tier1EntryInCart) {
                 self.cartDrawerContent.classList.add("updating-cart");
                 self.updateItemQuantity([{ id: singleEntryVariantId, quantity: 1 }]);
               }
               self.cartDrawer.classList.add('show-gift-selections', 'show-tier1');
            }
          }
          // Above tier2 threshold
          else if (currentCartValue >= tier2GwpThreshold) {
            console.log('asdsad');
            // Remove tier1 gift if present
            if(tier1EntryInCart == true) {
              if (tier1GwpInCart && tier1GwpInCart) {
                 self.cartDrawerContent.classList.add("updating-cart");
                 self.updateItemQuantity([
                  { id: singleEntryVariantId, quantity: 0 },
                  { key: tier1GwpInCart.key, quantity: 0 }
                ]); 
              } else {
                self.updateItemQuantity([{ id: singleEntryVariantId, quantity: 0 }]);
              }
            } else {
              if (tier1GwpInCart) {
                 self.cartDrawerContent.classList.add("updating-cart");
                 self.updateItemQuantity([{ key: tier1GwpInCart.key, quantity: 0 }]);
              }
            }
            if (tier1GwpInCart) {
              self.cartDrawerContent.classList.add("updating-cart");
              self.updateItemQuantity([{ key: tier1GwpInCart.key, quantity: 0 }]);
            }
            // Show tier2 selection if no tier2 gift
            if (!tier2GwpInCart) {
              if(multipleEntryVariantId != null && !tier2EntryInCart) {
                 self.cartDrawerContent.classList.add("updating-cart");
                 self.updateItemQuantity([{ id: multipleEntryVariantId, quantity: 1 }]);
               }
              self.cartDrawer.classList.add('show-gift-selections', 'show-tier2');
            }
          }
          
          self.updateThresholdTiers(currentCartValue);
      }
if (enableProductBasedGWP) {
  console.log("Checking GWP conditions");
  
  // First check if any products are from the trigger collection
  let hasCollectionProduct = false;
  if (collectionVariantIds && collectionVariantIds.length > 0) {
    // Log for debugging
    console.log("Collection Variant IDs:", collectionVariantIds);
    console.log("Cart Products:", productsInCartArray);
    
    hasCollectionProduct = productsInCartArray.some(cartItem => 
      collectionVariantIds.includes(cartItem.id)
    );
    
    // Log the result
    console.log("Has Collection Product:", hasCollectionProduct);
  }
  
  // If no collection match, check for size triggers
  let has100mlProduct = false;
  let has50mlProduct = false;
  
  if (!hasCollectionProduct) {
    if (productBasedGwpTrigger100) {
      const products100ml = productsInCartArray.filter(item => 
        item.title.includes("100ml")
      );
      has100mlProduct = products100ml.length > 0;
    }
    
    if (productBasedGwpTrigger50) {
      const products50ml = productsInCartArray.filter(item => 
        item.title.includes("50ml")
      );
      has50mlProduct = products50ml.length > 0;
    }
  }

  // Check for existing GWPs
  const productBasedGWPs = productsInCartArray.filter(product => 
    product.id === productBasedGwpVariantId && 
    product.properties && 
    product.properties['_GwpType'] === 'single'
  );

  // Set the progress variable based on whether we have GWPs in the cart
  let productBasedProgress = productBasedGWPs.length > 0;

  // Determine if we need to add a GWP based on the conditions
  const shouldAddGwp = hasCollectionProduct || 
                      (productBasedGwpTrigger100 && has100mlProduct) || 
                      (productBasedGwpTrigger50 && has50mlProduct);

  console.log("Should Add GWP:", shouldAddGwp);
  console.log("Existing GWPs:", productBasedGWPs.length);

  if (shouldAddGwp) {
    // Only add a GWP if there isn't one already in the cart
    if(productBasedGWPs.length === 0) {
      self.cartDrawerContent.classList.add("updating-cart");
      self.addItemsToCart([
        {
          id: productBasedGwpVariantId,
          quantity: 1,
          properties: { '_GwpType': 'single' }
        }
      ]);
      productBasedProgress = true;
    }
  } else {
    // No qualifying products - remove any gifts
    if (productBasedGWPs.length > 0) {
      self.cartDrawerContent.classList.add("updating-cart");
      const removeItems = productBasedGWPs.map(item => ({
        key: item.key,
        quantity: 0
      }));
      self.updateItemQuantity(removeItems);
      productBasedProgress = false;
    }
  }
  
  // Call the free shipping calculator with the current status at the end
  self.freeShippingCalculator(currentCartValue, productBasedProgress);
}
        //self.cartHeaderTotal.innerHTML = self.formatMoney(currentCartValue,self.moneyFormat);
      })
      .catch(function (response) {
        console.error("Error while fetching the cart:", response);
      });
  }),
    
    (AgileCart.prototype.formatMoney = function (amount) {
      console.log("formatMoney");
      return this.settings.moneyFormat.replace("{{amount}}", amount);
    });

  (AgileCart.prototype.fetchHandler = function (
    cart,
    cartItemTotal,
    currentCartValue
  ) {
    this.cartItemCount(cartItemTotal);
    if (cart.item_count === 0) {
      this.renderBlankCartDrawer();
    } else {
      //this.cartCollection.classList.add("is-invisible");
      this.renderDrawerCart(cart, currentCartValue);
      this.cartDrawerFooter.classList.remove("is-invisible");
    }
  }),
    
    (AgileCart.prototype.cartItemCount = function (cartItemTotal) {
      this.cartCount.innerHTML = cartItemTotal;
    }),
    (AgileCart.prototype.addItemToCart = function (formId) {
      console.log("addItemToCart");
      var self = this,
        formElement = document.querySelector("#" + formId); // Correctly target the form by its ID

      if (!formElement) {
        console.error("Form not found: #" + formId);
        return; // Exit if form not found
      }

      // Create FormData object from the form
      var formData = new FormData(formElement);
      console.log(formData);

      // Convert FormData to URL-encoded string
      var formDataObj = new URLSearchParams();
      formData.forEach(function (value, key) {
        formDataObj.append(key, value);
      });

      console.log(formDataObj.toString());

      window
        .fetch("/cart/add.js", {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: formDataObj.toString(), // Use the URL-encoded string
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cartResponse) {
          self.openCartOverlay();
          self.fetchCart(); // Handle cart count update
        })
        .catch(function (error) {
          self.ajaxRequestFail(); // Make sure this method is defined to handle request failures
          console.error("Error adding item to cart: ", error);
        });
    });

  AgileCart.prototype.addItemsToCart = function (itemsArray) {
    console.log("addItemsToCart");
    var self = this;

    // Create an array to hold the line items
    var items = [];

    // Loop through each item in the array
    itemsArray.forEach(function (item) {
      var lineItem = {
        id: item.id,
        quantity: item.quantity,
        properties: item.properties,
      };

      // Add this line item to the items array
      items.push(lineItem);
    });

    // Prepare the data for the POST request
    const data = {
      items: items,
    };

    console.log("Data to send:", data);

    // Make a single fetch request to add all items in one call
    window
      .fetch("/cart/add.js", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(data), // Use JSON format to send multiple line items
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cartResponse) {
        console.log("All items added to cart:", cartResponse);
        self.openCartOverlay();
        self.fetchCart(); // Fetch the updated cart after all items are added
      })
      .catch(function (error) {
        self.ajaxRequestFail(); // Handle request failures
        console.error("Error adding items to cart: ", error);
      });
  };

  AgileCart.prototype.addItemToCartSearch = function (wrapperId) {
    var self = this;

    // Find the hidden input within the wrapper
    var variantId = wrapperId;
    console.log(variantId);

    if (!variantId) {
      console.error("Variant ID input not found");
      return; // Exit if the variant input is not found
    }

    // Create an object to submit. Adjust the object structure as per your needs.
    var formDataObj = { id: variantId };

    window
      .fetch("/cart/add.js", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formDataObj), // Use the object directly
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cartResponse) {
        self.fetchCart(); // Handle cart count update
      })
      .catch(function (error) {
        self.ajaxRequestFail(); // Make sure this method is defined to handle request failures
        console.error("Error adding item to cart: ", error);
      });
  };

  AgileCart.prototype.changeItemQuantity = function (lineNumber, quantity) {
    console.log("changeItemQuantity");
    var self = this;
    window
      .fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({ quantity: quantity, line: lineNumber }),
        headers: { "Content-Type": "application/json" },
      })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        return self.fetchCart();
      })
      .catch(function (error) {
        self.ajaxRequestFail();
        console.error(error);
      });
  };

  AgileCart.prototype.updateItemQuantity = function (productUpdates) {
    console.log("updateItemQuantity");
    var self = this;

    const data = {
      updates: {},
      properties: {}
    };

    productUpdates.forEach((update) => {
      const { id, key, quantity, properties } = update;
      
      // If key is provided, use it; otherwise use id
      const updateKey = key || id;
      data.updates[updateKey] = quantity;
      
      if (properties) {
        data.properties[updateKey] = properties;
      }
    });

    // Set up the request options for the Fetch API
    const options = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    };

    // Set up the URL for the Ajax API call
    const apiUrl = "/cart/update.js";

    // Make the API call using the Fetch API
    fetch(apiUrl, options)
      .then((response) => response.json())
      .then((data) => console.log(data))
      .catch((error) => console.error(error))
      .finally(() => {
        self.openCartOverlay();
        self.fetchCart();
      });
};
  AgileCart.prototype.removeItem = function (lineNumber) {
    console.log("removeItem");
    var self = this;
    window
      .fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({ quantity: 0, line: lineNumber }),
        headers: { "Content-Type": "application/json" },
      })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        return self.fetchCart();
      })
      .catch(function (error) {
        self.ajaxRequestFail();
        console.error(error); // Log the error instead of throwing it
      });
  };

  AgileCart.prototype.removeItemsByKeys = function (keys) {
    var self = this;

    // Split the keys into an array, as they are comma-separated
    const keyArray = keys.split(",").filter(Boolean); // Filter out any empty strings

    // Log keys for debugging purposes
    console.log("Keys to remove:", keyArray);

    // Create an object to hold the updates
    const updates = {};

    // Loop through each key in the array and set quantity to 0
    keyArray.forEach(function (key) {
      if (key && key.length > 0) {
        // Make sure it's not an empty string
        console.log("Adding item to remove with id:", key); // Log each id before removal
        updates[key.trim()] = 0; // Set quantity to 0 for this id
      } else {
        console.error("Invalid id encountered:", key);
      }
    });

    // Log the full update payload for debugging
    console.log("Sending batch remove request with updates:", updates);

    // Make a single fetch request to batch remove the items
    fetch("/cart/update.js", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        updates: updates, // Send the entire updates object in one request
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          console.error("Failed to remove items, Response:", response);
          throw new Error("Failed to remove items");
        }
        return response.json();
      })
      .then(function (data) {
        console.log("Items successfully removed:", data);
        self.fetchCart(); // Fetch the updated cart after all items are removed
      })
      .catch(function (error) {
        console.error("Error removing items:", error);
      });
  };

  AgileCart.prototype.removeAll = function () {
    console.log("removeAll");
    var self = this;
    window
      .fetch("/cart/clear.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
      })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        return self.fetchCart();
      })
      .catch(function (error) {
        self.ajaxRequestFail();
        console.error(error); // Log the error instead of throwing it
      });
  };

  // Utility methods
  AgileCart.prototype.openCartOverlay = function () {
    document.body.classList.add("overflow-hidden");
    this.settings.cartDrawer.classList.add("is-open");
    this.settings.cartOverlay.classList.add("is-open");
  };

  AgileCart.prototype.closeCartOverlay = function () {
    document.body.classList.remove("overflow-hidden");
    this.settings.cartDrawer.classList.remove("is-open");
    this.settings.cartOverlay.classList.remove("is-open");
  };

  AgileCart.prototype.renderBlankCartDrawer = function () {
    console.log("renderBlankDrawer");
    this.cartDrawerContent.classList.add("empty-cart");
    //this.cartShippingDisclaimer.classList.add("is-invisible");
    if(this.cartCollection) {
      this.cartCollection.classList.remove("is-invisible");
    }
    this.cartDrawerFooter.classList.add("is-invisible");
    if(this.cartShippingWrapper) {
      this.cartShippingWrapper.classList.add("is-invisible");
    }
    //this.clearCart();
    this.cartDrawerContent.innerHTML = `
            <div class="go-cart__empty">
               <svg class="icon icon-cart" role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                 <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                 <line x1="3" y1="6" x2="21" y2="6"></line>
                 <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
              Your cart is empty
              <a href="/collections/scents" class="button button-solid">Continue Shopping</a>
            </div>
           `;
  };

  AgileCart.prototype.renderBlankCartPage = function () {
    console.log("renderBlankPage");
    var cartItems = document.querySelector(".cart__items");
    document.querySelector(".cart-totals-wrapper").style.display = "none";
    if (cartItems) {
      document.querySelector(".cart__items").style.display = "none";
    }
    document.querySelector(".cart__warnings").style.display = "flex";
    this.clearCart();
  };

  AgileCart.prototype.renderDrawerCart = function (cart, currentCartValue) {
    var emptyCartElement = this.cartDrawerContent.querySelector(".go-cart__empty");

    // Check if the element exists before trying to remove it
    if (emptyCartElement) {
      emptyCartElement.remove();
    }
    this.cartDrawerContent.classList.remove("empty-cart");
    if(this.cartShippingWrapper) {
      this.cartShippingWrapper.classList.remove("is-invisible");
    }
    var self = this;

    console.log("renderDrawerCart");

    // Show the overlay
    // Start simulating progress
    const progressBar = document.querySelector(".progress-bar-inner");
    if (progressBar) {
      progressBar.style.width = "0%"; // Reset progress
      setTimeout(() => (progressBar.style.width = "100%"), 100); // Start progress
    }

    Promise.all([
      fetch("/?section_id=cart-drawer-items", {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
        },
      }),
      fetch("/?section_id=cart-drawer-footer", {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
        },
      })
    ])
    .then(responses => Promise.all(responses.map(response => response.text())))
    .then(([itemsHtml, footerHtml]) => {
        // Inject the new HTML into respective containers
        self.cartDrawerContent.innerHTML = itemsHtml;
        self.cartDrawerFooter.innerHTML = footerHtml;
        if (sessionStorage.getItem('hideLayeredOptions') === 'true') {
          const layeredOptions = self.cartDrawerContent.querySelectorAll('.layered-products-suggestions');
          layeredOptions.forEach(element => {
            element.style.display = 'none';
          });
        }

        self.cartDrawerContent.classList.remove("updating-cart");
        if (progressBar) {
          progressBar.style.width = "0%";
        }

      })
      .catch((error) => console.error("Error updating cart drawer:", error));
  };

  AgileCart.prototype.renderCartPage = function (cart) {
    var self = this;
    let updatedCartPrice = 0;
    console.log("renderCartPage");

    const progressBar = document.querySelector(".progress-bar");
    progressBar.style.width = "0%"; // Reset progress
    setTimeout(() => (progressBar.style.width = "100%"), 100); // Start progress

    fetch("/?section_id=cart-page-items", {
      method: "GET",
      headers: {
        "Content-Type": "text/html",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        // Inject the new HTML into the cart drawer
        self.cartPageContent.innerHTML = html;

        self.cartPageContent.classList.remove("updating-cart");
        progressBar.style.width = "0%"; // Reset progress bar for the next update
        self.updateCartSubtotal();
        self.cartHeaderTotal.innerHTML = self.formatMoney(
          cart.total_price,
          self.moneyFormat
        );
        const liquorAgeCheck = document.querySelector(".liquor-check-age");
        if (hasLiquor) {
          liquorAgeCheck.classList.add("show-liquor-age-check");
        } else {
          liquorAgeCheck.classList.remove("show-liquor-age-check");
        }
      })
      .catch((error) => console.error("Error updating cart drawer:", error));
  };

  AgileCart.prototype.updateCartSubtotal = function () {
    console.log("updateCartSubtotal");
    var self = this;

    fetch("/?section_id=cart-totals")
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const checkoutElement = doc.getElementById("checkout");

        // Inject the modified HTML into the totals wrapper
        document.querySelector(".totals-wrapper").innerHTML =
          doc.body.innerHTML;
      })
      .catch((error) => console.error("Error updating cart subtotal:", error));
  };

  AgileCart.prototype.openCartOverlay = function () {
    this.cartDrawer.classList.add("is-open");
    this.cartOverlay.classList.add("is-open");
  };

  AgileCart.prototype.closeCartOverlay = function () {
    this.cartDrawer.classList.remove("is-open");
    this.cartOverlay.classList.remove("is-open");
  };

  AgileCart.prototype.removeItemAnimation = function (element) {
    if (element) element.classList.add("is-invisible");
  };

  AgileCart.prototype.clearCart = function () {
    console.log("clearCart");
    this.cartDrawerContent.innerHTML = "";
  };

  // Free Shipping Calculator
  (AgileCart.prototype.freeShippingCalculator = function (currentCartValue, productBasedProgress) {
  var self = this;
  var percentage;
  var newProgressNum;
  console.log(productBasedProgress);

    
  // Convert currentCartValue from cents to dollars for display
  let displayValue = currentCartValue / 100;

  if (enableProductBasedGWP) {
    if(productBasedProgress == true) {
      document.querySelector('.cart-shipping__numOuter').style.display = 'none';
      self.cartSuccessMessage.style.display = "block";
      percentage = 100;
      self.cartProgressBar.forEach(function (el) {
        el.setAttribute("style", `width: ${percentage}%`);
      });
      document.querySelectorAll('.cart-shippingThreshold__bar img').forEach(function (el) {
        el.setAttribute("style", `left: ${percentage}%;`);
      });
    } else {
      percentage = 0;
      document.querySelector('.cart-shipping__numOuter').style.display = 'block';
      self.cartSuccessMessage.style.display = "none";
      self.cartProgressBar.forEach(function (el) {
        el.setAttribute("style", `width: ${percentage}%`);
      });
      document.querySelectorAll('.cart-shippingThreshold__bar img').forEach(function (el) {
        el.setAttribute("style", `left: ${percentage}%;`);
      });
    }
  }

  if (currentCartValue < freeShippingThreshold) {
    percentage = (currentCartValue / freeShippingThreshold) * 100;
    newProgressNum = ((freeShippingThreshold - currentCartValue) / 100).toFixed(2);
    
    document.querySelectorAll('.threshold__text').forEach(function (el) {
      el.style.display = "inline";
    });
    document.querySelector('.free-shipping__success').style.display = "none";
  } else {
    percentage = 100;
    newProgressNum = 0;
    document.querySelectorAll('.threshold__text').forEach(function (el) {
      el.style.display = "none";
    });
    document.querySelector('.free-shipping__success').style.display = "block";
  }

  document.querySelectorAll('.free-shippingThreshold__progress').forEach(function (el) {
    el.setAttribute("style", `width: ${percentage}%`);
  });
  document.querySelectorAll('.free-shippingThreshold__bar img').forEach(function (el) {
    el.setAttribute("style", `left: ${percentage}%;`);
  });

  document.querySelectorAll('.free-shipping__num').forEach(function (el) {
    el.textContent = "$" + newProgressNum;
  });

  document.querySelector('.free-shipping__numOuter').style.display = currentCartValue >= freeShippingThreshold ? "none" : "block";
    
  if (enableTieredGwpDollarThreshold) {
    // Calculate percentage based on tier2 threshold (100%)
    percentage = (currentCartValue / tier2GwpThreshold) * 100;
    
    if (currentCartValue < tier1GwpThreshold) {
      // Haven't reached tier1 yet
      newProgressNum = ((tier1GwpThreshold - currentCartValue) / 100).toFixed(2);
      self.shippingThresholdTextWrapper.forEach(function (el) {
        el.innerHTML = ' ' + tier1GwpMessage;
      });
      self.cartSuccessMessage.style.display = "none";
    } else if (currentCartValue < tier2GwpThreshold) {
      // Between tier1 and tier2
      newProgressNum = ((tier2GwpThreshold - currentCartValue) / 100).toFixed(2);
      self.shippingThresholdTextWrapper.forEach(function (el) {
        el.innerHTML = ' ' + tier2GwpMessage;
      });
      self.cartSuccessMessage.style.display = "none";
    } else {
      // Reached tier2
      newProgressNum = 0;
      percentage = 100;
      self.cartSuccessMessage.style.display = "block";
    }

    // Add visual marker for tier1 threshold
    const tier1Percentage = (tier1GwpThreshold / tier2GwpThreshold) * 100;
    self.cartProgressBar.forEach(function (el) {
      el.setAttribute("style", `width: ${percentage}%`);
    });
    document.querySelectorAll('.cart-shippingThreshold__bar img').forEach(function (el) {
      el.setAttribute("style", `left: ${percentage}%;`);
    });

  } else if (enableGwpDollarThreshold) {
    // Single GWP logic
    if (currentCartValue < singleGwpThreshold) {
      percentage = (currentCartValue / singleGwpThreshold) * 100;
      newProgressNum = ((singleGwpThreshold - currentCartValue) / 100).toFixed(2);
      
      self.shippingThresholdTextWrapper.forEach(function (el) {
        el.innerHTML = ' ' + singleGwpMessage;
      });
      self.cartSuccessMessage.style.display = "none";
    } else {
      percentage = 100;
      newProgressNum = 0;
      self.cartSuccessMessage.style.display = "block";
    }

    self.cartProgressBar.forEach(function (el) {
      el.setAttribute("style", `width: ${percentage}%`);
    });
    document.querySelectorAll('.cart-shippingThreshold__bar img').forEach(function (el) {
      el.setAttribute("style", `left: ${percentage}%;`);
    });
  }

  self.numberElement.forEach(function (el) {
    el.textContent = "$" + newProgressNum;
  });

  self.freeShippingProgress.forEach(function (el) {
    if (enableTieredGwpDollarThreshold) {
      el.style.display = currentCartValue >= tier2GwpThreshold ? "none" : "block";
    } else if (enableGwpDollarThreshold) {
      el.style.display = currentCartValue >= singleGwpThreshold ? "none" : "block";
    }
  });
});

  AgileCart.prototype.updateThresholdTiers = function(currentCartValue) {
  // Convert currentCartValue from cents to dollars
  const cartValue = currentCartValue / 100;
  
  // Get all threshold-tiers elements
  const thresholdTiers = document.querySelectorAll('.threshold-tiers');
  
  thresholdTiers.forEach(tierContainer => {
    const thresholdSpans = tierContainer.querySelectorAll('span');
    
    thresholdSpans.forEach(span => {
      // Get the threshold value from the span text
      const thresholdValue = parseInt(span.textContent.replace('$', ''));
      
      // Add or remove class based on whether cart value exceeds threshold
      if (cartValue >= thresholdValue) {
        span.classList.add('threshold-met');
      } else {
        span.classList.remove('threshold-met');
      }
    });
  });
};

  AgileCart.prototype.formatMoney = function (cents, format) {
    console.log();
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || "${{amount}}";

    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ",",
      decimal = "."
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  function fetchJSONP(url, callbackParamName) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      const callbackFunctionName = `jsonp_callback_${Math.round(
        100000 * Math.random()
      )}`;

      window[callbackFunctionName] = function (data) {
        delete window[callbackFunctionName];
        document.body.removeChild(script);
        resolve(data);
      };

      // Ensure correct URL formatting
      const separator = url.includes("?") ? "&" : "?";
      script.src = `${url}${separator}${callbackParamName}=${callbackFunctionName}`;
      script.onerror = function () {
        delete window[callbackFunctionName];
        document.body.removeChild(script);
        reject(new Error("Script load error"));
      };
      document.body.appendChild(script);
    });
  }
  // Make sure to implement ajaxRequestFail as needed

  window.AgileCart = AgileCart;
})(window, document);

var agileCart = new AgileCart({});
